<template>
    <div class="modal fade" 
        :class="this.modalPosition" 
        :id="modalID" 
        :aria-labelledby="theModalLabel" 
        tabindex="-1"
        aria-hidden="true"
        @click.self="close">

        <div class="np-base-dialog modal-dialog modal-lg modal-dialog-centered w-100" :class="modalClass">
            <div class="modal-content shadow">
                <div class="modal-header border-0 p-4 pb-2">
                    <span class="col-sm-8 d-flex align-middle">
                        <svg class="icon"><use href="@/assets/images/icons/cog.svg#icon"></use></svg>
                        {{ this.isNewEmployee ? $t("UI.employee.employee") : $t("UI.employee.addEmployee") }}
                    </span>
                    <div class="d-flex justify-content-end flex-grow-1">
                        <button type="button" class="np-btn np-outline" data-bs-dismiss="modal" aria-label="Close">
                            <svg><use href="@/assets/images/icons/close3.svg#icon"></use></svg> 
                        </button>
                    </div>
                </div>
                <form>
                    <div class="modal-body ps-3 pe-3">
                        <div class="row m-0 w-100 h-100">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-3">
                                        <CoverUploader
                                            :initialImage="employeeData.imageFile"
                                            :placeholder="$t('UI.settings.avatar')"
                                            :updateCover="setAvatarFile"
                                            :removeCover="removeAvatarFile"
                                        />
                                    </div>    
                                    <div class="col-9">
                                        <div class="row">
                                            <div class="col">
                                                <div class="mb-4">
                                                    <label class="np-font-m np-f-medium mb-1">{{ $t("auth.firstname") }}</label>
                                                    <input type="text" class="form-control np-input" id="projectName" aria-describedby="departmentHelp" v-model="employeeData.first_name" required>
                                                    <small v-if="errors.first_name" class="invalid-feedback">{{ errors.first_name }}</small>
                                                </div> 
                                            </div>
                                            <div class="col">
                                                <div class="mb-4">
                                                    <label class="np-font-m np-f-medium mb-1">{{ $t("auth.surname") }}</label>
                                                    <input type="text" class="form-control np-input" id="projectName" aria-describedby="departmentHelp" v-model="employeeData.last_name">
                                                    <small v-if="errors.last_name" class="invalid-feedback">{{ errors.last_name }}</small>
                                                </div>                                                                                                 
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <div class="mb-4">
                                                    <label class="np-font-m np-f-medium mb-1">{{ $t("UI.organization.department") }}</label>
                                                    <vSelect 
                                                        class="align-items-center flex-grow-1" 
                                                        placeholder="" 
                                                        v-model="employeeData.department_id"
                                                        label="title"
                                                        :clearable="false"
                                                        :reduce="dep => dep.id"
                                                        :options="departments"
                                                    > 
                                                            <template #option="{ title, firstLevelChild }">
                                                                <p v-if="firstLevelChild" class="ms-3">{{ title }}</p>
                                                                <p v-else class="np-f-bold">{{ title }}</p>
                                                            </template>                                                     
                                                    </vSelect>
                                                    <small v-if="errors.department" class="invalid-feedback">{{ errors.department }}</small>
                                                </div> 
                                            </div>
                                            <div class="col">
                                                <label class="np-font-m np-f-medium mb-1">
                                                    {{ $t("UI.employee.position") }}
                                                </label>                                                
                                                <div class="d-flex align-items-center mb-4">
                                                    <div class="flex-grow-1 me-2">
                                                        <vSelect 
                                                            class="align-items-center flex-grow-1" 
                                                            placeholder="" 
                                                            v-model="employeeData.position_id"
                                                            label="name"
                                                            :clearable="false"
                                                            :reduce="pos => pos.id"
                                                            :options="positions" 
                                                        />                                                      
                                                        <small v-if="errors.position" class="invalid-feedback">{{ errors.position }}</small>
                                                    </div>            
                                                    <div class="dropdown dropstart">
                                                        <button class="np-btn np-btn-link" 
                                                            id="positionDropdownMenuLink" 
                                                            role="button" 
                                                            data-bs-toggle="dropdown" 
                                                            aria-expanded="false">
                                                            <svg><use href="@/assets/images/icons/dots-vertical.svg#icon"></use></svg>
                                                        </button>
                                                        <ul class="dropdown-menu" aria-labelledby="positionDropdownMenuLink">
                                                            <li class="dropdown-item">
                                                                <button type="button" class="btn btn-link btn-sm me-2 text-body-tertiary" @click="callPositionsAdd">
                                                                    <img src="@/assets/images/icons/plus.svg" /> {{ $t("UI.employee.addPosition") }}
                                                                </button>
                                                            </li>
                                                            <li class="dropdown-item">
                                                                <button type="button" class="btn btn-link btn-sm me-2 text-body-tertiary" @click="callPositionsEdit" :disabled="!employeeData.position_id">
                                                                    <img src="@/assets/images/icons/edit.svg" /> {{ $t("UI.employee.editPosition") }}
                                                                </button>                                                            
                                                            </li>
                                                        </ul>
                                                    </div>                                                                                                                                                             
                                                </div>                                                                                     
                                            </div>                                            
                                        </div> 
                                        <div class="row">
                                            <div class="col">
                                                <h3 class="np-header3 pt-2 pb-4">{{ $t("UI.employee.contacts") }}</h3>
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="mb-4">
                                                            <label class="np-font-m np-f-medium mb-1">{{ $t("auth.email") }}</label>
                                                            <input type="email" class="form-control np-input" aria-describedby="employeeEmail" v-model="employeeData.mail" required>
                                                            <small v-if="errors.mail" class="invalid-feedback">{{ errors.mail }}</small>
                                                        </div>                                                         
                                                    </div>
                                                    <div class="col">
                                                        <div class="mb-4">
                                                            <label class="np-font-m np-f-medium mb-1">{{ $t("auth.phone") }}</label>
                                                            <input type="text" class="form-control np-input" aria-describedby="employeePhone" v-model="employeeData.phone" required>
                                                            <small v-if="errors.phone" class="invalid-feedback">{{ errors.phone }}</small>
                                                        </div>                                                         
                                                    </div>                                                    
                                                </div>

                                                <h3 class="np-header3 pt-2 pb-4">{{ $t("UI.employee.authData") }}</h3>
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="mb-4">
                                                            <label class="np-font-m np-f-medium mb-1">{{ $t("auth.username") }}</label>
                                                            <input type="text" class="form-control np-input" id="projectName" aria-describedby="departmentHelp" v-model="employeeData.login" required>
                                                            <small v-if="errors.login" class="invalid-feedback">{{ errors.login }}</small>
                                                        </div>                                                         
                                                    </div>
                                                    <div class="col">
                                                        <div class="mb-4">
                                                            <label class="np-font-m np-f-medium mb-1">{{ $t("auth.password") }}</label>
                                                            <div class="np-group">
                                                                <input :type="showPassword ? 'text' : 'password'" class="form-control np-input" id="projectName" aria-describedby="departmentHelp" v-model="employeeData.password" required>
                                                                <button class="np-btn np-btn-link ms-1" @click="showPassword = !showPassword">
                                                                    <svg v-if="showPassword" class="icon"><use href="@/assets/images/icons/eye2.svg#icon"></use></svg>
                                                                    <svg v-else class="icon"><use href="@/assets/images/icons/eye2-close.svg#icon"></use></svg>   
                                                                </button>
                                                            </div>
                                                            <small v-if="errors.password" class="invalid-feedback">{{ errors.password }}</small>
                                                        </div>                                                         
                                                    </div>                                                    
                                                </div>  
                                                
                                                <div class="row mt-4 mb-4">
                                                    <div class="col">
                                                        <span class="np-font-ml mt-3 mb-1">{{ $t("UI.employee.isStaff") }}</span>
                                                        <div class="form-check form-switch">
                                                            <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked v-model="employeeData.is_staff">
                                                        </div> 
                                                    </div>
                                                    <div class="col">
                                                        <span class="np-font-ml mt-4 mb-1">{{ $t("UI.employee.isAdmin") }}</span>
                                                        <div class="form-check form-switch">
                                                            <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" v-model="employeeData.is_admin">
                                                        </div>           
                                                    </div>                                  
                                                </div>  

                                                <div class="row mb-1 mb-4">
                                                    <div class="col-4">
                                                        <h3 class="np-header3 np-pt-2 np-pb-2">{{ $t("UI.employee.spaceLimit") }}</h3>

                                                        <label class="np-font-m np-f-medium mb-1">{{ $t("UI.employee.spaceLimitLabel") }}</label>
                                                        <input type="number" min="0" class="form-control np-input" id="limitSpace" aria-describedby="departmentHelp" v-model="employeeData.limit_space_file">
                                                        <small id="departmentHelp" class="invalid-feedback"></small>                                                      
                                                    </div>
                                                </div>                                                                                               
                                            </div>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>                      
                    </div>
                </form>
                <div class="modal-footer p-3">
                    <button type="button" class="np-btn np-danger px-4 me-1"
                        data-bs-dismiss="modal">{{ $t("UI.close") }}</button>
                    <div role="button" class="np-btn np-success-filled px-4" @click="save()">{{ $t("UI.save") }}</div>
                </div>                    
            </div>
        </div>
    </div>
</template>

<script>
import { useOrganizationStore } from '@/stores/organizationStore'
import CoverUploader from "@/components/elements/CoverUploader.vue"
import DatePicker from 'vue-datepicker-next'
import { createToast } from 'mosha-vue-toastify' 
import 'vue-datepicker-next/index.css'
import { Modal } from "bootstrap"
import { ref } from 'vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Config from '../../config'

export default {
    components: {
        flatPickr,
        CoverUploader,
        DatePicker
    },
    props: {
        modalID: {
            type: String,
            required: true
        },        
        modalSize: {
            type: String,
            default: ''
        },
        modalPosition: {
            type: String,
            default: ''
        }          
    }, 
    data() {
        return {  
            Config,
            employeeData: {},
            theModal: null,
            theModalLabel: null,
            showPassword: false,
            errors: {}
        }
    },    
    computed: {
        isNewEmployee() {
            return !!this.employeeData.id
        },
        organizationStore() {
            return useOrganizationStore()
        },     
        positions() {
            return this.organizationStore.positions
        },
        departments() {
            const deps = []
            this.organizationStore.departments.forEach(dep => {
                deps.push({
                    id: dep.id,
                    title: dep.title,
                    rootElement: true
                })
                dep.child.forEach(sDep => {
                    deps.push({
                        id: sDep.id,
                        title: sDep.title,
                        firstLevelChild: true
                    })
                })
            })
            return deps
        }        
    },
    mounted: function () {
        var IdModal = '#' + this.$props.modalID
        this.theModalLabel = this.modalID + "Label"
        this.theModal = new Modal(IdModal, {backdrop: true})
    },           
    methods: {
        validateForm() {
            this.errors = {}

            if (!this.employeeData.mail) {
                this.errors.mail = this.$t("error.mustBeNotEmpty")
            } else if (!/^\S+@\S+\.\S+$/.test(this.employeeData.mail)) {
                this.errors.mail = this.$t("error.wrongEmailFormat")
            }

            if (!this.employeeData.password && !this.employeeData.id) {
                this.errors.password = this.$t("error.mustBeNotEmpty")
            }

            if (!this.employeeData.first_name) {
                this.errors.first_name = this.$t("error.mustBeNotEmpty")
            }

            if (!this.employeeData.department_id) {
                this.errors.department = this.$t("error.mustBeNotEmpty")
            }            

            if (!this.employeeData.position_id) {
                this.errors.position = this.$t("error.mustBeNotEmpty")
            }

            if (!this.employeeData.login) {
                this.errors.login = this.$t("error.mustBeNotEmpty")
            }                                                

            return Object.keys(this.errors).length === 0
        },        
        shows(empInfo) {
            this.employeeData = {} // Полная очистка
            this.errors = {}
            this.$nextTick(() => {
                this.employeeData = Object.assign({}, empInfo)
                this.theModal.show()
            })
        },
        hide() {
            this.close()
            this.theModal.hide()
        },
        async close() {
            this.$emit('closeModal', this.employeeData.id)
        },
        async save() {
            //this.employeeData.status_id = 1 // NEED TO BE CHANGED!!!
            if (this.validateForm()) {
                const emp = await this.organizationStore.updateEmployee(this.employeeData)
                this.$emit('afterSave', emp)
                this.hide()
            } else {
                createToast({ description: this.$t("error.code0") }, Config.TOAST_CONFIG_ERROR) 
            }
        }, 
        callPositionsAdd() {
            this.$emit('positionEdit', {})
        },
        callPositionsEdit() {
            const selectedPosition = this.positions.find(pos => pos.id === this.employeeData.position_id)
            this.$emit('positionEdit', selectedPosition)
        },
        setAvatarFile(file) {
            this.employeeData.avatar = file
        },
        async removeAvatarFile() {
            const res = await this.organizationStore.removeEmployeeAvatar(this.employeeData.id)

            if (res)
                this.employeeData.avatar = null
        }
    }
}
</script>

<style>
    .modal {
        backdrop-filter: blur(5px);
    }
</style>